import { Controller } from "@hotwired/stimulus"

const ORDINAL_LABELS = [ "First child", "Second child", "Third child", "Fourth child" ]

export default class extends Controller {
  static targets = [ "row", "label", "addButton" ]
  static values = { max: Number }

  rowTargetConnected() {
    this.refresh()
  }

  rowTargetDisconnected() {
    this.refresh()
  }

  refresh() {
    const visibleRows = this.visibleRows()

    this.updateLabels(visibleRows)
    this.toggleAddButton(visibleRows.length)
  }

  visibleRows() {
    return this.rowTargets.filter(row => !row.classList.contains("hidden"))
  }

  updateLabels(visibleRows) {
    visibleRows.forEach((row, index) => {
      const label = row.querySelector('[data-ambassador-children-target="label"]')
      if (label) label.textContent = ORDINAL_LABELS[index] || ""
    })
  }

  toggleAddButton(visibleCount) {
    if (!this.hasAddButtonTarget) return

    const isDisabled = visibleCount >= this.maxValue

    this.addButtonTarget.disabled = isDisabled
    this.addButtonTarget.classList.toggle("opacity-50", isDisabled)
    this.addButtonTarget.classList.toggle("cursor-not-allowed", isDisabled)
  }
}
